<template>
  <pop-up-menu class="idioms">
    <div slot="pop-up-label" class="idioms__label">
      <span class="idioms__idiom">{{ $t('login.idiom') }}:</span> {{ language.label }}
    </div>
    <div slot="pop-up-body">
      <div class="idioms__list">
        <div
          class="idioms__item"
          role="button"
          v-for="languageItem in idiomsList"
          :key="languageItem.key"
          @click="changeLanguage(languageItem)"
        >
          {{ languageItem.label }}
        </div>
      </div>
    </div>ManageFonts
  </pop-up-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'language',
      'languages',
    ]),
    idiomsList() {
      return this.languages.filter(lang => lang.key !== this.language.key);
    },
  },
  methods: {
    ...mapActions([
      'setLanguage',
    ]),
    changeLanguage(language) {
      this.setLanguage(language);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .idioms
    color: #fff
    display: flex
    flex-direction: column

    &__list
      display: flex
      flex-direction: column
      color: var(--font-color-primary)
      min-width: 70px
    &__idiom
      font-weight: 600
    &__item
      margin-top: 10px
      cursor: pointer
      &:first-child
        margin-top: 0
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>
